import Input from '../../../../../Core/Fields/Floating/Input';
import Date from '../../../../../Core/Fields/Floating/Date';
import SelectSearch from '../../../../../Core/Fields/Floating/SelectSearch';
import Checkbox from '../../../../../Core/Fields/Floating/Checkbox';

const GeneralDetailsTab1 = ({ formData, onFieldChange, extraData }) => {

    return (
        <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Details</p>
                                    </div>
                                </div>
                                    
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                
                                    <Input label="Series" style={{ height: "30px" }} value={formData.series} onChange={(e) => onFieldChange('series', e.target.value)} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Date label="Date" style={{ height: "30px" }} value={formData.date_of_visit} onChange={(e) => onFieldChange('date_of_visit', e.target.value)} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input label="Customer" style={{ height: "30px" }} value={formData.customer} onChange={(e) => onFieldChange('customer', e.target.value)} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <Date label="Delivery Date" style={{ height: "30px" }} value={formData.date_of_visit} onChange={(e) => onFieldChange('date_of_visit', e.target.value)} />

                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input label="Select Billing Type" style={{ height: "30px" }} value={formData.customer} onChange={(e) => onFieldChange('customer', e.target.value)} />
                                </div>
                                 <div style={{ flex: 1 }}>
                                    <Input label="Select Order Type" style={{ height: "30px" }} value={formData.customer} onChange={(e) => onFieldChange('customer', e.target.value)} />
                                </div>
                                {/* <div style={{ flex: 1 }}>
                                    <div style={{ flex: 1 }}>
                                <label style={{height:'19px'}}></label>
                                     <Checkbox
                                            id="ASNInclusion"
                                            label="ASN Inclusion"
                                        />
                                </div>
                                </div> */}
                                {/* <div style={{ flex: 1 }}>
                                <label style={{height:'19px'}}></label>
                                     <Checkbox
                                            id="IsSubcontracted"
                                            label="Is Subcontracted"
                                        />
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                           <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Accounting Dimensions</p>
                                    </div>
                                </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                          
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        list={extraData.customer_types}
                                        label="Cost Center"
                                        style={{ height: "30px" }}
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        value={formData.company}
                                        onChange={(e) => onFieldChange('customer_type', e.target.value)}

                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        list={extraData.customer_types}
                                        label="Project"
                                        style={{ height: "30px" }}
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        value={formData.company}
                                        onChange={(e) => onFieldChange('customer_type', e.target.value)}

                                    />
                                </div>
                            </div>

                             <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='mt-2 mb-0' style={{fontSize:'16px',fontWeight:'600'}}>Currency and Price List</p>
                                    </div>
                                </div>
                            <div style={{ display: 'flex', gap: '15px', marginBottom: '10px' }}>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        label="Currency"
                                        list={extraData.assigned_to}

                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        style={{ height: "30px" }}
                                        value={formData.assigned_to}
                                        onChange={(e) => onFieldChange('assigned_to', e.target.value)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        label="Price List"
                                        list={extraData.helped_by}

                                        style={{ height: "30px" }}
                                        value={formData.help_by}
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        onChange={(e) => onFieldChange('help_by', e.target.value)}
                                    />
                                </div>

                                <div style={{ flex: 1 }}>
                                <label style={{height:'19px'}}></label>
                                     <Checkbox
                                            id="IgnorePricingRule"
                                            label="Ignore Pricing Rule"
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
   
        </div>
    );
};

export default GeneralDetailsTab1;